import { IApplicationState } from '../../types/redux';

export const selectRedirectAuthorizationModal = (state: IApplicationState): string | null =>
  state.calculator.authorizationModal.redirectUrl;
